const MenuInjectionKey = Symbol("MenuInjectionKey");
const LevelInjectionKey = Symbol("LevelInjectionKey");
const DataCollectorInjectionKey = Symbol("DataCollectorInjectionKey");
export { DataCollectorInjectionKey, LevelInjectionKey, MenuInjectionKey };
